import { useAppSelector } from 'Douleutaras/redux/hooks';

export const useConversationsInfo = () => {
  const unseenMessageCounts = useAppSelector(state =>
    state.conversations);

  return {
    unseenConversationsCount: unseenMessageCounts.unseenConversationsCount,
    unseenBuyerConversationsCount: unseenMessageCounts.unseenBuyerConversationsCount,
    unseenSellerConversationsCount: unseenMessageCounts.unseenSellerConversationsCount,
    chatEnabled: unseenMessageCounts.chatEnabled
  };
};
